import React, {FC, useState} from 'react';
import {UseFormClearErrors, UseFormRegister, UseFormSetError, UseFormSetValue, UseFormWatch} from 'react-hook-form';
import {Student} from '../../shared/types/student';
import HLFormInput from '../../shared/components/input/HLFormInput';
import HLErrorMessage from '../../shared/components/error-message/HLErrorMessage';
import HLIconButton from '../../shared/components/icon-button/HLIconButton';
import CloseIcon from '../../shared/styles/icons/CloseIcon';
import PlusIcon from '../../shared/styles/icons/PlusIcon';
import StudentSearchModal from '../../modal/student/StudentSearchModal';
import classes from './Selector.module.scss';
import {AgreementStudentStructure} from "../../shared/types/agreement";

interface StudentSelectorProps {
    register: UseFormRegister<any>;
    setError: UseFormSetError<any>;
    clearErrors: UseFormClearErrors<any>;
    setValue: UseFormSetValue<any>;
    watch: UseFormWatch<any>;
    errors: any;
}

const StudentSelector: FC<StudentSelectorProps> = ({
                                                       register,
                                                       setError,
                                                       clearErrors,
                                                       setValue,
                                                       watch,
                                                       errors
                                                   }) => {
    const [isStudentSearchOpen, setIsStudentSearchOpen] = useState(false);

    register('selectedStudents', {
        validate: value => {
            if (!value || value.length === 0) return 'Должен быть хотя бы один ученик';
        }
    });

    const selectedStudents: AgreementStudentStructure[] = watch('selectedStudents');


    const openStudentModal = () => setIsStudentSearchOpen(true);

    const addStudent = (student: Student) => {
        if (!selectedStudents) {
            setValue('selectedStudents', [{...student}]);
        } else if (!selectedStudents.find((item: AgreementStudentStructure) => item.id === student.id)) {
            setValue('selectedStudents', [...selectedStudents, {...student}]);
        }

        clearErrors('selectedStudents');
        setIsStudentSearchOpen(false);
    };

    const deleteStudent = (studentId: number) => {
        if (!selectedStudents) {
            return;
        }

        setValue('selectedStudents', selectedStudents.filter((selectedStudent: AgreementStudentStructure) => selectedStudent.id !== studentId));
        if (selectedStudents.length <= 1) {
            setError('selectedStudents', {type: 'required', message: 'Должен быть хотя бы один ученик'});
        }
    };

    return (
        <>
            <div className="columnContainer">
                <div className="inlineContainer">
                    <h3>Ученики</h3>
                    <HLIconButton
                        type="button"
                        icon={<PlusIcon/>}
                        onClick={openStudentModal}
                        aria-label="Добавить студента"
                    />
                </div>

                {selectedStudents && selectedStudents.map((selectedStudent: AgreementStudentStructure, index: number) => (
                    <div key={selectedStudent.id} className="columnContainer">
                        <div className="inlineContainer">
                            <div className={classes.dynamicInput}>
                                <HLFormInput
                                    id={`student-${selectedStudent.id}`}
                                    value={`${selectedStudent.firstName} ${selectedStudent.lastName || ''}`}
                                    readOnly
                                    placeholder="Ученик"
                                />
                            </div>
                            <div className={classes.dynamicButton}>
                                <HLIconButton
                                    icon={<CloseIcon/>}
                                    onClick={() => deleteStudent(selectedStudent.id)}
                                    aria-label="Удалить студента"
                                />
                            </div>
                        </div>
                        <div className="inlineContainer">
                            <div className={classes.dynamicInput}>
                                <HLFormInput
                                    id={`lessonPrice-${selectedStudent.id}`}
                                    type="number"
                                    step="0.01"
                                    min="0.01"
                                    {...register(`selectedStudents.${index}.lessonPrice`, {
                                        required: 'Цена урока обязательна',
                                        valueAsNumber: true,
                                        min: {value: 0.01, message: 'Цена должна быть больше 0'}
                                    })}
                                    placeholder="Цена урока"
                                    error={errors.selectedStudents?.[index]?.lessonPrice?.message}
                                />
                            </div>

                            <div className={classes.dynamicInput}>
                                <HLFormInput
                                    id={`availableLessons-${selectedStudent.id}`}
                                    type="number"
                                    step="1"
                                    {...register(`selectedStudents.${index}.availableLessons`, {
                                        required: 'Кол-во уроков обязательно',
                                        valueAsNumber: true,
                                    })}
                                    placeholder="Кол-во доступных уроков"
                                    error={errors.selectedStudents?.[index]?.availableLessons?.message}
                                />
                            </div>
                        </div>
                    </div>
                ))}

                <HLErrorMessage error={errors.selectedStudents?.message}/>
            </div>

            <StudentSearchModal
                open={isStudentSearchOpen}
                setOpen={setIsStudentSearchOpen}
                onSelect={addStudent}
            />
        </>
    );
};

export default StudentSelector;